/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-07-05T19:13:41.171
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentRepairFeedbackDetails,
	listRentRepairFeedbackDetailsInit,
	listRentRepairFeedbackDetailsByAuthorizations,
	deleteRentRepairFeedbackDetails,
	listRentRepairFeedbackDetailsInitBySQL
	
} from '@api/rentmanage/RentRepairFeedbackDetails';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentRepairFeedbackDetails({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentRepairFeedbackDetails(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentRepairFeedbackDetailsByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentRepairFeedbackDetailsByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		listRentRepairFeedbackDetailsInitBySQL({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentRepairFeedbackDetailsInitBySQL(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentRepairFeedbackDetailsInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentRepairFeedbackDetailsInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentRepairFeedbackDetails({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentRepairFeedbackDetails({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
